import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useRealtimeFrame } from '../../shared/api/realtime';
import {
  addCustomDomain,
  checkCustomDomain,
  listCustomDomains,
  removeCustomDomain,
} from '../../entities/custom-domain';

const KEY = ['custom-domains'];

export const useCustomDomains = () => {
  const client = useQueryClient();
  const refresh = () => client.invalidateQueries({ queryKey: KEY });

  // The worker pushes every step a domain takes; the list is read again rather than patched.
  useRealtimeFrame('custom_domain.changed', () => void refresh());

  const domains = useQuery({ queryKey: KEY, queryFn: listCustomDomains });

  const add = useMutation({ mutationFn: addCustomDomain, onSuccess: refresh });
  const check = useMutation({ mutationFn: checkCustomDomain, onSuccess: refresh });
  const remove = useMutation({ mutationFn: removeCustomDomain, onSuccess: refresh });

  return { domains, add, check, remove };
};
